import { createReducer, on } from '@ngrx/store';
import { LocationModel } from './location.model';
import { resetLocation, setLocation } from './location.actions';

const initialStateLocation: LocationModel = {
  latitude: 19.0414, // Puebla Centro
  longitude: -98.2063 // Puebla Centro
};

export const locationReducer = createReducer(
  initialStateLocation,
  on(setLocation, (state, { latitude, longitude }) => ({
    ...state,
    latitude,
    longitude
  })),
  on(resetLocation, () => initialStateLocation)
);